import { useMutation, useQueryClient } from 'react-query';
import { sharedWorkflowService } from 'api/services';
import { useSiteDetection } from 'shared/hooks';
import { UseArchiveWorkflowProps } from './use-archive-workflow.types';
import { QUERY_KEYS } from '../../../../../../../../../api/query-keys';

export const useArchiveWorkflow = (receivedOptions?: UseArchiveWorkflowProps) => {
  const { site } = useSiteDetection();
  const queryClient = useQueryClient();

  return useMutation(
    async (workflowId: string) => {
      return await sharedWorkflowService.archiveWorkflow(site, workflowId);
    },
    {
      ...receivedOptions,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(QUERY_KEYS.workflows());
        if (receivedOptions?.onSuccess) {
          receivedOptions.onSuccess(data, variables, context);
        }
      },
    }
  );
};
